import apiClient from './apiClient';

export const textbausteinApi = {
  getAll: async (kategorie) => {
    const params = kategorie ? `?kategorie=${kategorie}` : '';
    const response = await apiClient.get(`/textbausteine${params}`);
    return response.data;
  },

  bulkAction: async (ids, action) => {
    const response = await apiClient.patch('/textbausteine/bulk', { ids, action });
    return response.data;
  },

  create: async (data) => {
    const response = await apiClient.post('/textbausteine', data);
    return response.data;
  },

  update: async (id, data) => {
    const response = await apiClient.put(`/textbausteine/${id}`, data);
    return response.data;
  },

  delete: async (id) => {
    const response = await apiClient.delete(`/textbausteine/${id}`);
    return response.data;
  }
};

export default textbausteinApi;
